import styled from 'styled-components';

export const VideoBackground = styled.section`
  margin-bottom: 40px;
  width: 100%;
  height: 100%;

  &.player-wrapper {
    position: relative;
    padding-top: 56.25%;
  }
`;
